module.exports = __webpack_public_path__ + "img/red-wrong.00f74c66.svg";